(function () {
  'use strict';

  window.scroll(0, 0);

  String.prototype.isValidEmail = function () {
    return /^[a-z0-9.]+@[a-z0-9]+\.[a-z]+(\.([a-z]+))?$/i.test(this);
  };

  function formatPhoneNumber(e) {
    var x = e.target.value
      .replace('+55', '')
      .replace(/\D/g, '')
      .match(/(\d{0,2})(\d{0,5})(\d{0,4})/);
    e.target.value = !x[1] ? x[0] : '+55 (' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
  }

  function spinner() {
    return '<div class="spinner__wrapper"><span class="spinner"></span></div>';
  }

  function parseHTML(str) {
    const parser = new DOMParser();

    return parser.parseFromString(str, 'text/html');
  }

  function sendQuizFormData({ email, phone }, ids, attribute = null) {
    try {
      if (!Array.isArray(ids)) throw new Error('The argument "ids" must be an array.');

      window.insider_object = window.insider_object || {};

      window.insider_object.user = {
        email: email,
        phone_number: phone,
        language: 'pt-br',
        gdpr_optin: true,
        email_optin: true,
        list_id: ids,
        custom: attribute,
      };

      Insider.eventManager.dispatch('init-manager:re-initialize');
    } catch (err) {
      console.error(err);
    }
  }

  try {
    class QuizContainer extends HTMLElement {
      constructor() {
        super();

        this.currentSlide = 1;
        this.slides = document.querySelectorAll('.quiz-question--section');
        this.slideCount = this.slides.length + 1;
        this.style.setProperty('--slide-count', (this.slideCount || 0) + 2);

        window.scroll(0, 0);

        this.points = {
          nutrition: 0,
          hidratation: 0,
          reconstruction: 0,
          multifuncional: 0,
          antifrizz: 0,
          cachos: 0,
        };

        this._resizeContainer(0);
      }

      connectedCallback() {
        this.querySelectorAll(
          '.quiz-question__answer-input[type="radio"], .quiz-question__answer-input--no-alternative',
        ).forEach((btn) => {
          btn.addEventListener('change', this._next.bind(this));
        });
        this.querySelectorAll('.quiz-question__answer-input[type="checkbox"]').forEach((btn) => {
          btn.addEventListener('change', this._hideInfoTitle.bind(this));
        });

        this.querySelectorAll('[data-next]').forEach((btn) => {
          btn.addEventListener('click', this._next.bind(this));
        });

        this.querySelectorAll('[data-previous]').forEach((btn) => {
          btn.addEventListener('click', this._previous.bind(this));
        });
      }

      _next(e) {
        e.preventDefault();

        this.currentSlide = Math.min(this.slideCount, this.currentSlide + 1);
        this.style.setProperty('--current-slide', this.currentSlide);

        window.scroll(0, 0);

        this.acumuledPoints();
        this._changeSlide(this.currentSlide, 'next');
      }

      _previous(e) {
        e.preventDefault();

        const slide = this.children.item(this.currentSlide);

        slide.querySelectorAll('input').forEach((input) => {
          input.checked = false;
        });

        this.currentSlide = Math.max(0, this.currentSlide - 1);
        this.style.setProperty('--current-slide', this.currentSlide);

        window.scroll(0, 0);

        this.acumuledPoints();
        this._changeSlide(this.currentSlide, 'previous');
      }

      _hideInfoTitle(e) {
        e.preventDefault();

        const question = e.target.closest('.quiz-question');
        const checkedAnswers = question.querySelectorAll('input:checked').length;
        const infoTitle = question.querySelector('.quiz-question__info');

        if (checkedAnswers > 0) {
          infoTitle.style.opacity = 0;
        } else {
          infoTitle.style.opacity = 1;
        }
      }

      acumuledPoints() {
        const points = {
          nutrition: 0,
          hidratation: 0,
          reconstruction: 0,
          multifuncional: 0,
          antifrizz: 0,
          cachos: 0,
        };

        this.querySelectorAll('.quiz-question__answer-input:checked').forEach((opt) => {
          points.nutrition += parseInt(opt.dataset.nutrition);
          points.hidratation += parseInt(opt.dataset.hidratation);
          points.reconstruction += parseInt(opt.dataset.reconstruction);
          points.multifuncional += parseInt(opt.dataset.multifuncional);
          points.antifrizz += parseInt(opt.dataset.antifrizz);
          points.cachos += parseInt(opt.dataset.cachos);
        });

        this.points = points;
      }

      _resizeContainer(slideIndex) {
        try {
          const slide = this.slides[Math.max(0, slideIndex - 1)];
          const section = slide?.querySelector('.section');

          if (section) {
            this.style.height = `${section.offsetHeight}px`;
          }
        } catch (err) {
          console.error(err);
        }
      }

      _changeSlide(slideIndex, action) {
        this._resizeContainer(slideIndex || 0);

        document.dispatchEvent(
          new CustomEvent('slide:change', {
            bubbles: true,
            detail: {
              slideIndex,
              action: 'action:' + action,
              points: this.points,
            },
          }),
        );
      }
    }
    if (!window.customElements.get('quiz-container')) {
      window.customElements.define('quiz-container', QuizContainer);
    }

    class QuizProgress extends HTMLElement {
      constructor() {
        super();

        this.quizContainer = document.querySelector('quiz-container');
        this.stepsCount = Math.max(0, parseInt(this.quizContainer.style.getPropertyValue('--slide-count') || 0) - 2);
      }

      connectedCallback() {
        for (let i = 0, j = this.stepsCount; i < j; i++) {
          const HTMLSpan = document.createElement('span');

          this.appendChild(HTMLSpan);
        }

        document.addEventListener('slide:change', this._update.bind(this));

        document.dispatchEvent(
          new CustomEvent('slide:change', {
            bubbles: true,
            detail: {
              slideIndex: 1,
            },
          }),
        );
      }

      _update(e) {
        e.preventDefault();
        e.stopPropagation();

        const steps = this.children;
        const slideIndex = e.detail.slideIndex;

        for (let i = 1, j = steps.length + 1; i < j; i++) {
          const step = steps.item(i - 1);

          if (i < slideIndex) {
            step.classList.add('completed');
            step.classList.remove('current');
          } else if (i == slideIndex) {
            step.classList.add('current');
          } else {
            step.classList.remove('completed', 'current');
          }
        }

        if (slideIndex === 0 || slideIndex === document.querySelector('quiz-container').children.length - 1) {
          this.style.opacity = 0;
        } else {
          this.style.opacity = 1;
        }
      }
    }
    if (!window.customElements.get('quiz-progress')) {
      window.customElements.define('quiz-progress', QuizProgress);
    }

    class QuizAnswer extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const emailInput = this.querySelector('#quiz-question-email');
        const phoneInput = this.querySelector('#quiz-question-phone-number');

        if (emailInput !== null) {
          emailInput.addEventListener('keyup', this._validEmail.bind(this));
        }

        if (phoneInput !== null) {
          phoneInput.addEventListener('keyup', this._validPhone.bind(this));
        }
      }

      _validEmail(e) {
        e.preventDefault();

        const button = this.querySelector('#quiz-question-view-result');
        const phoneInput = this.querySelector('#quiz-question-phone-number');

        if (button !== null) {
          if (e.currentTarget.value.isValidEmail()) {
            button.disabled = false;
          } else {
            button.disabled = true;
          }
        }
      }
      _validPhone(e) {
        formatPhoneNumber(e);

        const button = this.querySelector('#quiz-question-view-result');
        const emailInput = this.querySelector('#quiz-question-email');

        if (button !== null) {
          if (e.currentTarget.value.length === 19 && emailInput.value.isValidEmail()) {
            button.disabled = false;
          } else {
            button.disabled = true;
          }
        }
      }
    }
    if (!window.customElements.get('quiz-answer')) {
      window.customElements.define('quiz-answer', QuizAnswer);
    }

    class QuizAnswersList extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {}
    }
    if (!window.customElements.get('quiz-answers-list')) {
      window.customElements.define('quiz-answers-list', QuizAnswersList);
    }

    class QuizResults extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        document.addEventListener('slide:change', this._render.bind(this));
      }

      async _render(e) {
        e.preventDefault();
        e.stopPropagation();

        const data = e.detail;

        if (data.slideIndex == document.querySelector('quiz-container').children.length - 1) {
          const quizQuestionEmail = document.querySelector('#quiz-question-email');
          const quizQuestionPhone = document.querySelector('#quiz-question-phone-number');

          if (quizQuestionEmail !== null && quizQuestionPhone !== null) {
            const listID = document.querySelector('#quiz-question-list-id').value;

            if (listID !== null && typeof sendQuizFormData === 'function') {
              const points = {
                nutrition: 0,
                hidratation: 0,
                reconstruction: 0,
                multifuncional: 0,
                antifrizz: 0,
                cachos: 0,
              };
              const result = {
                type: '',
                points: 0,
                data: null,
              };
              const inputText = document.querySelector('[name="question_answer_text"]');

              document.querySelectorAll('.quiz-question__answer-input:checked').forEach((opt) => {
                points.nutrition += parseInt(opt.dataset.nutrition);
                points.hidratation += parseInt(opt.dataset.hidratation);
                points.reconstruction += parseInt(opt.dataset.reconstruction);
                points.multifuncional += parseInt(opt.dataset.multifuncional);
                points.antifrizz += parseInt(opt.dataset.antifrizz);
                points.cachos += parseInt(opt.dataset.cachos);
              });

              for (let type in points) {
                if (points[type] > result.points) {
                  result.points = points[type];
                  result.type = type;
                  result.data = quizResultsOptions.find((i) => i.type == type);
                  result.description = points[type].description;
                }
              }

              const quizResult = {
                quiz_result_points: result.points,
                quiz_result_type: result.type,
                quiz_text: inputText !== null ? inputText.value : '',
              };

              const attributes = {};

              document.querySelectorAll('[data-question]:checked').forEach((el) => {
                if (typeof attributes[el.dataset.question] === 'undefined') {
                  attributes[el.dataset.question] = [];
                }

                attributes[el.dataset.question].push(el.dataset.answer);
              });

              for (let attr in attributes) {
                quizResult[attr] = attributes[attr].join(',');
              }

              sendQuizFormData(
                {
                  email: quizQuestionEmail.value,
                  phone: quizQuestionPhone.value.replace(/[^0-9]/, ''),
                },
                [listID.value],
                quizResult,
              );
            }
          }

          /* Request the winner products */
          if (typeof quizResultsOptions !== 'undefined') {
            const { points } = data;
            const result = {
              type: '',
              points: 0,
              data: null,
            };

            for (let type in points) {
              if (points[type] > result.points) {
                result.points = points[type];
                result.type = type;
                result.data = quizResultsOptions.find((i) => i.type == type);
                result.description = points[type].description;
              }
            }

            if (result.data !== null) {
              try {
                const inputText = document.querySelector('[name="question_answer_text"]');

                window.quizResult = {
                  quiz_result_points: result.points,
                  quiz_result_type: result.type,
                  quiz_text: inputText !== null ? inputText.value : '',
                };

                const productPageHTML = await fetch(
                  '/products/' + result.data.featured_product + '?section_id=main-product',
                ).then((r) => r.text());

                const doc = parseHTML(productPageHTML);
                const productHTML = doc.querySelector('.shopify-section--main-product');
                const container = this.closest('.main__sections');
                const quizDescription = document.querySelector('#quiz-result-description');
                const quizInfographic = document.querySelector('#infographic-text');

                if (container) {
                  container.style.height = 'auto';
                }

                if (productHTML) {
                  const resultTarget = this.querySelector('#quiz-result-product');

                  if (resultTarget !== null) {
                    resultTarget.innerHTML = '';
                    resultTarget.append(productHTML);
                  }
                } else {
                  console.error('Produto não encontrado.');
                }

                if (quizDescription) {
                  quizDescription.innerHTML = parseHTML(result.data.description).body.innerHTML;
                }

                if (quizInfographic) {
                  quizInfographic.innerHTML = parseHTML(result.data.infographic_text).body.innerHTML;
                }

                const productsList = document.querySelector('#quiz-result-secondary-products');

                productsList.innerHTML = '';

                for (let i = 0, j = result.data.handles.length; i < j; i++) {
                  try {
                    const handle = result.data.handles[i];
                    const itemProductHTML = await fetch(handle + '?section_id=card-product').then((r) => r.text());

                    const doc = parseHTML(itemProductHTML);

                    productsList.append(doc.querySelector('product-card'));
                  } catch (err) {
                    console.error(err);
                  }
                }

                const buttonsWrapper = document.querySelector('.quiz-results__buttons-wrapper');
                if (buttonsWrapper !== null) {
                  buttonsWrapper.style.display = 'block';
                }
              } catch (err) {
                console.error(err);
              }
            }
          }

          /** Render items */
          const pointsBar = this.querySelectorAll('.quiz-results__type-points');

          pointsBar.forEach((bar) => {
            const type = bar.dataset.type;
            const items = bar.querySelectorAll('.quiz-results__points > span');
            const value = Math.min(10, Math.max(0, data.points[type]));

            items.forEach((item, i) => {
              if (i < value) {
                item.classList.add('fill');
              }
            });
          });
        } else {
          setTimeout(() => {
            const quizResult = this.querySelector('#quiz-result-product');
            if (quizResult !== null) {
              quizResult.innerHTML = spinner();
            }
          }, 400);

          this.querySelectorAll('.quiz-results__points > span').forEach((item) => {
            item.classList.remove('fill');
          });

          const buttonsWrapper = document.querySelector('.quiz-results__buttons-wrapper');
          if (buttonsWrapper !== null) {
            buttonsWrapper.style.display = 'none';
          }
        }
      }
    }
    if (!window.customElements.get('quiz-results')) {
      window.customElements.define('quiz-results', QuizResults);
    }

    class QuizModal extends HTMLElement {
      constructor() {
        super();

        this.buttons = document.querySelectorAll('.quiz-results__email-button');
      }

      connectedCallback() {
        this.buttons.forEach((button) => {
          button.addEventListener('click', this._open.bind(this));
        });
        this.querySelector('.quiz-modal__box-close').addEventListener('click', this._close.bind(this));
        window.addEventListener('keyup', (e) => {
          if (e.code === 'Escape') {
            this._close(e);
          }
        });
        document.addEventListener('click', (e) => {
          if (e.target.classList.contains('quiz-modal') || e.target.classList.contains('quiz-modal__box-close')) {
            this._close(e);
          }
        });
        this.querySelector('form').addEventListener('submit', this._submit.bind(this));
        this.querySelector('#quiz-modal-email').addEventListener('keyup', this._emailKeyup.bind(this));
        this.querySelector('#quiz-modal-phone-number').addEventListener('keyup', this._phoneKeyup.bind(this));
      }

      _open(e) {
        e.preventDefault();
        document.body.classList.add('quiz-modal--opened');
      }

      _close(e) {
        e.preventDefault();
        document.body.classList.remove('quiz-modal--opened');
      }

      _submit(e) {
        e.preventDefault();

        const form = e.target;
        const email = form.querySelector('#quiz-modal-email').value;
        const phone = form.querySelector('#quiz-modal-phone-number').value.replace(/[^0-9]/, '');
        const listIDs = form.querySelector('#quiz-modal-list-id').value.split(',');

        if (typeof sendQuizFormData === 'function') {
          form.classList.remove('sent');
          form.classList.add('sending');

          const attributes = quizResult || null;

          document.querySelectorAll('[data-question]:checked').forEach((el) => {
            if (typeof attributes[el.dataset.question] === 'undefined') {
              attributes[el.dataset.question] = [];
            }

            attributes[el.dataset.question].push(el.dataset.answer);
          });

          sendQuizFormData({ email, phone }, listIDs, attributes);

          setTimeout(function () {
            form.classList.remove('sending');
            form.classList.add('sent');
          }, 2000);
        }
      }

      _emailKeyup(e) {
        e.preventDefault();

        const input = e.target;
        const phone = document.querySelector('#quiz-modal-phone-number');
        const button = document.querySelector('#quiz-modal-button');

        if (input.value.isValidEmail() && phone.value.length === 19) {
          if (button) {
            button.disabled = false;
          }
        } else {
          if (button) {
            button.disabled = true;
          }
        }
      }
      _phoneKeyup(e) {
        const email = document.querySelector('#quiz-modal-email');
        const button = document.querySelector('#quiz-modal-button');

        formatPhoneNumber(e);

        if (email.value.isValidEmail() && e.currentTarget.value.length === 19) {
          if (button) {
            button.disabled = false;
          }
        } else {
          if (button) {
            button.disabled = true;
          }
        }
      }
    }
    if (!window.customElements.get('quiz-modal')) {
      window.customElements.define('quiz-modal', QuizModal);
    }
  } catch (err) {
    console.error(err);
  }
})(window);
